module.exports = __webpack_public_path__ + "static/media/alla_logo.d58db61d.png";